import { Alert } from "@mui/material";
import { ReactElement } from "react";

import { CampaignWithSuppressionData } from "~frontend/routes/types";
import { jobFailed } from "~frontend/util/jobs";

export default function SuppressionErrors({
  campaign,
}: {
  campaign: CampaignWithSuppressionData;
}): ReactElement {
  return (
    <>
      {campaign.calculateCampaignOverlapsJob &&
        jobFailed(campaign.calculateCampaignOverlapsJob).failed && (
          <Alert severity="error">
            Failed to calculate campaign overlaps:{" "}
            {jobFailed(campaign.calculateCampaignOverlapsJob).errorMessage}
          </Alert>
        )}
      {campaign.createSuppressionsFromCampaignOverlapsJob &&
        jobFailed(campaign.createSuppressionsFromCampaignOverlapsJob)
          .failed && (
          <Alert severity="error">
            Failed to suppress overlaps:{" "}
            {
              jobFailed(campaign.createSuppressionsFromCampaignOverlapsJob)
                .errorMessage
            }
          </Alert>
        )}
      {campaign.createSuppressionsFromListJob &&
        jobFailed(campaign.createSuppressionsFromListJob).failed && (
          <Alert severity="error">
            Failed to suppress contacts from list:{" "}
            {jobFailed(campaign.createSuppressionsFromListJob).errorMessage}
          </Alert>
        )}
      {campaign.createSuppressionsFromShortcodeSubscribersJob &&
        jobFailed(campaign.createSuppressionsFromShortcodeSubscribersJob)
          .failed && (
          <Alert severity="error">
            Failed to suppress short code subscribers:{" "}
            {
              jobFailed(campaign.createSuppressionsFromShortcodeSubscribersJob)
                .errorMessage
            }
          </Alert>
        )}
      {campaign.deleteSuppressionsJob &&
        jobFailed(campaign.deleteSuppressionsJob).failed && (
          <Alert severity="error">
            Failed to delete suppressions:{" "}
            {jobFailed(campaign.deleteSuppressionsJob).errorMessage}
          </Alert>
        )}
    </>
  );
}
